import React, { useContext } from 'react';
import {Sabko} from '../App';
import '../style/Design.css';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';

function Design() {
    const {state}=useContext(Sabko);
  return (
    <>
        <div className='designdiv'>

        <div className='Usercommd'>
          <div className='Usercommd1'>
            <h2 className='cmCntH'>CONTACT</h2>
          </div>
          <div className='Usercommd2'>
           {(state.User?.Personal?.name)&&(<h1  className='Upd1N'>{(state.User?.Personal?.name)}</h1>)}
           {(state.User?.Personal?.mail)&&(
            <h3  className='Upd1Cn'><MailOutlineIcon className='Upd1CnI'/>{(state.User?.Personal?.mail)}</h3>)}
           {(state.User?.Personal?.phone)&&(
            <h3 className='Upd1Cn'><PhoneIcon className='Upd1CnI'/>{(state.User?.Personal?.phone)}</h3>)}
           {(state.User?.Personal?.address)&&(
            <h3 className='Upd1Cn'><LocationOnIcon className='Upd1CnI'/>{(state.User?.Personal?.address)}</h3>
            )}
            
           
          </div>
        </div>
        {
          (state.User?.Objective)&&
        (<div className='Usercommd' >
        <div className='Usercommd1'>
          <h2 className='cmCntH'>Objective</h2>
        </div>
        <div className='Usercommd2'>
          <h4 className='onass'>{(state.User?.Objective)}</h4>
        </div>
        </div>)
        }
        
        {
          (state.User?.Education)&&
        (<div className='Usercommd' >
        <div className='Usercommd1'>
          <h2 className='cmCntH'>Education</h2>
        </div>
        <div className='Usercommd2'>
        {(state.User?.Education?.university)&&(
          <h4 className='Upd1N'> {(state.User?.Education?.university)} </h4>
            )}
        {(state.User?.Education?.degree)&&(
          <h4 className='isnj'>{(state.User?.Education?.degree)}</h4>
            )}
        {(state.User?.Education?.year)&&(
          <h4 className='isnj'>{(state.User?.Education?.year)}</h4>
            )}
        {(state.User?.Education?.score)&&(
          <h4 className='isnj'>{(state.User?.Education?.score)}</h4>
            )}
          
        </div>
        </div>)
        }

        {
          (state.User?.Skills)&&
        (<div className='Usercommd' >
        <div className='Usercommd1'>
          <h2 className='cmCntH'>Skills</h2>
        </div>
        <div className='Usercommd2'>
        {(state.User?.Skills.skill1)&&(
          <h4 className='isnj'>{(state.User?.Skills.skill1)}</h4>
            )}
        {(state.User?.Skills.skill2)&&(
          <h4 className='isnj'>{(state.User?.Skills.skill2)}</h4>
            )}
        {(state.User?.Skills.skill3)&&(
          <h4 className='isnj'>{(state.User?.Skills.skill3)}</h4>
            )}
        {(state.User?.Skills.skill4)&&(
          <h4 className='isnj'>{(state.User?.Skills.skill4)}</h4>
            )}
         
        </div>
        </div>)
        }

        {
          (state.User?.Projects)&&
        (<div className='Usercommd' style={{borderBottom:'none'}}>
        <div className='Usercommd1'>
          <h2 className='cmCntH'>Projects</h2>
        </div>
        <div className='Usercommd2'>
        {(state.User?.Projects.project1)&&(
          <h4 className='isnj'>{(state.User?.Projects.project1)}</h4>
            )}
        {(state.User?.Projects.project2)&&(
          <h4 className='isnj'>{(state.User?.Projects.project2)}</h4>
            )}
        {(state.User?.Projects.project3)&&(
          <h4 className='isnj'>{(state.User?.Projects.project3)}</h4>
            )}
        {(state.User?.Projects.project4)&&(
          <h4 className='isnj'>{(state.User?.Projects.project4)}</h4>
            )}
        </div>
        </div>)

        }

        </ div>
    </>
  )
}

export default Design